/* Generated from shared/wallet-settings/CategoryList.jsx. Do not edit this copy. */
import React, { useId, useState } from 'react';
import { createPortal } from 'react-dom';
import useListReorder from './useListReorder';
import './CategoryList.css';

function Grip() {
  return <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="3">
    <path d="M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01"/>
  </svg>;
}

function CategoryName({ item }) {
  return <span className="category-name"><i style={{ background: item.color }}/><strong>{item.name}</strong></span>;
}

export default function CategoryList({ categories, busy, onMove, onEdit, onDelete, Icon }) {
  const [pending, setPending] = useState(null);
  const [error, setError] = useState('');
  const [announcement, setAnnouncement] = useState('');
  const items = pending ?? categories;
  const locked = busy || pending !== null;
  const helpId = useId();

  async function move(id, beforeCategoryId) {
    if (locked) return;
    const index = categories.findIndex(item => item.id === id);
    if (index < 0 || (categories[index + 1]?.id ?? null) === beforeCategoryId) return;
    const next = categories.filter(item => item.id !== id);
    next.splice(beforeCategoryId === null ? next.length : next.findIndex(item => item.id === beforeCategoryId), 0, categories[index]);
    setError('');
    setAnnouncement('');
    setPending(next);
    try {
      const failure = await onMove(id, beforeCategoryId);
      if (failure) setError(failure);
      else setAnnouncement(`${categories[index].name} moved to position ${next.indexOf(categories[index]) + 1} of ${next.length}.`);
    } finally {
      setPending(null);
    }
  }

  const { listRef, overlayRef, drop, handleProps, rowProps, overlayStyle } = useListReorder({ items, locked, onMove: move });
  const dragged = drop && items.find(item => item.id === drop.itemId);
  return <div className="settings-items">
    {items.length > 1 && <p id={helpId} className="muted">Drag the handles to reorder, or focus a handle and use the arrow keys, Home or End.</p>}
    {!items.length && <p className="muted">Start by adding your first category.</p>}
    <div ref={listRef} className="category-order-list">
      {items.map(item => <div key={item.id} className="settings-item" data-category-id={item.id}
        data-dragging={drop?.itemId === item.id} {...rowProps(item.id)}>
        <div className="category-order-name">
          {items.length > 1 && <button type="button" className="icon-button category-order-handle"
            aria-label={`Reorder ${item.name}`} aria-describedby={helpId} aria-disabled={locked} {...handleProps(item.id)}>
            <Grip/>
          </button>}
          <CategoryName item={item}/>
        </div>
        <div className="row-actions">
          <button className="icon-button" disabled={locked} aria-label={`Edit ${item.name}`} onClick={() => onEdit({ ...item })}><Icon name="edit" size={17}/></button>
          <button className="icon-button danger" disabled={locked} aria-label={`Delete ${item.name}`} onClick={() => onDelete(item)}><Icon name="trash" size={17}/></button>
        </div>
      </div>)}
    </div>
    {error && <div className="alert" role="alert">{error}</div>}
    <span className="category-order-announcement" role="status">{announcement}</span>
    {dragged && createPortal(
      <div ref={overlayRef} className="category-order-overlay" aria-hidden="true" style={overlayStyle}>
        <div className="category-order-name">
          <span className="icon-button category-order-handle"><Grip/></span>
          <CategoryName item={dragged}/>
        </div>
      </div>, document.body,
    )}
  </div>;
}
